import { useEffect, useContext, useState } from "react";
import QlikCard from "components/QlikCard";
import QlikObject from "components/QlikObject";
import GlobalContext from "GlobalContext";


export default function StateSingleProjectPipeline({ title , appDisclaimer , pageTitle, ExportChartFootnote, menuItemsStrings}) {
  useEffect(() => {
    document.title = `${pageTitle} - ${title}`;
  }, [pageTitle,title]);

  const { app } = useContext(GlobalContext);
  const [err, setError] = useState(null);
  const [FilterHeightInvestmentProjects, setFilterHeight] = useState(688);

  useEffect(() => {
    app.model.waitForOpen.promise.then(() => {
      setTimeout(async () => {
        app.model.enigmaModel.evaluate("$(=count({1}distinct [_col_id_investmentprojects]))").then(async (reply) => {
          const InvestmentProjectsNumberOfFilterRows = reply*27+40;
          console.log('InvestmentProjectsNumberOfFilterRows/Number of rows: ', InvestmentProjectsNumberOfFilterRows);
          setFilterHeight(InvestmentProjectsNumberOfFilterRows);
        }).catch(err => {
          if(!err) setError(err);
        });
      }, 500);
    });
  }, [app, err])

  return (
    <section className="content">
      <div className="content-header">
        <div className="row mb-2">
          <div className="col-md-10 col-sm-9 col-10">
            <h5 className="page-title"> {title} </h5>
            {/* <h6 className="page-disclaimer"> {appDisclaimer} </h6> */}
          </div>
          {/* <div className="col-md-2 col-sm-3 col-4">
            <QlikObject id="GqNcZ" height="35px" showLoader={false} />
          </div> */}
          <div className="col-md-2 col-sm-3 col-2">
            <QlikObject
              id="c0e6ed11-8ddd-44c4-8f15-ae470172d98b"
              height="30px"
              showLoader={false}
            />
          </div>
        </div>
      </div>

      <div className="container-fluid">

        <div className="row justify-content-start">

            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-10 col-xl-10">

              <div className="row justify-content-left">
                {/* KPIs Row */}

                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                      {/* KPI: total projects and programs */}
                      <QlikCard
                        id="332835dd-7d11-4ddc-835f-ab8ad3372ac1"
                        height="190px"
                        showHeader={false}
                        showMaximize={false}
                        showExport={false}
                      />
                    </div>

                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                      {/* KPI: total total projects and programs needs */}
                      <QlikCard
                        id="TAqzVC"
                        height="190px"
                        showHeader={false}
                        showMaximize={false}
                        showExport={false}
                      />
                    </div>

              </div>


              <div className="row justify-content-left">
                {/* Charts Row */}

                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-6">
                  {/* bar chart column */}
                  <div className="row justify-content-center">
                    <div className="col-12">
                      {/* bar chart 1*/}
                      <QlikCard
                        id="ece1a8b9-fb77-41b6-8a15-396dabc6698b"
                        height="min(calc(78vh - 263px), calc(320px + 38px))"
                        showHeader={true}
                        showMaximize={false}
                        showExport={true}
                        showPdfExport
                        showImageExport={true}
                        exportImageWidth={1280}
                        exportImageHeight={720}
                        onBeforeExportHandler={async ({ vis, exportType }) => {
                          //console.log(data);
                          console.log(vis);
                          if(exportType in { pdf: true, image: true} && vis)
                            await vis.setOptions({ showTitles: true, footnote: `${ExportChartFootnote}` });
                        }}
                        onAfterExportHandler={async ({ vis, exportType }) => {
                          console.log('Export type: ', exportType);
                          if(exportType in { pdf: true, image: true})
                            vis.setOptions({ showTitles: false, footnote:"" });
                        }}
                        exportText = {menuItemsStrings.exportText}
                        exportCompletedText = {menuItemsStrings.exportCompletedText}
                        closeBtnText = {menuItemsStrings.closeBtnText}
                        exportSelectObjectText={menuItemsStrings.exportSelectObjectText}
                        exportNoObjectText={menuItemsStrings.exportNoObjectText}
                      />
                    </div>
                  </div>

                </div>

                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-6">
                  {/* bar chart column */}
                  <div className="row justify-content-center">
                    <div className="col-12">
                      {/* bar chart 2*/}
                      <QlikCard
                        id="55c7c7d4-7f45-4e2a-bdd6-8559890798ea"
                        height="min(calc(78vh - 263px), calc(320px + 38px))"
                        showHeader={true}
                        showMaximize={false}
                        showExport={true}
                        showPdfExport
                        showImageExport={true}
                        exportImageWidth={1280}
                        exportImageHeight={720}
                        onBeforeExportHandler={async ({ vis, exportType }) => {
                          //console.log(data);
                          console.log(vis);
                          if(exportType in { pdf: true, image: true} && vis)
                            await vis.setOptions({ showTitles: true, footnote: `${ExportChartFootnote}` });
                        }}
                        onAfterExportHandler={async ({ vis, exportType }) => {
                          console.log('Export type: ', exportType);
                          if(exportType in { pdf: true, image: true})
                            vis.setOptions({ showTitles: false, footnote:"" });
                        }}
                        exportText = {menuItemsStrings.exportText}
                        exportCompletedText = {menuItemsStrings.exportCompletedText}
                        closeBtnText = {menuItemsStrings.closeBtnText}
                        exportSelectObjectText={menuItemsStrings.exportSelectObjectText}
                        exportNoObjectText={menuItemsStrings.exportNoObjectText}
                      />
                    </div>
                  </div>

                </div>

              </div>

              <div className="row justify-content-left">
                {/* Table Row */}

                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                  {/* straight table */}
                  <div className="row justify-content-center">
                    <div className="col-12">
                      {/* table */}
                      <QlikCard
                        id="bf121fa3-42dd-4d3b-8295-3e27e5b9725d"
                        height="max(calc(100vh - 365px)/2 + 161px, 380px)"
                        showHeader={true}
                        showMaximize={true}
                        showExport={true}
                        onBeforeExportHandler={async ({  }) => {
                            await app.variable.setStringValue('export_link', '1');
                        }}
                        onAfterExportHandler={async ({  }) => {
                            app.variable.setStringValue('export_link', '0');
                        }}
                        exportText = {menuItemsStrings.exportText}
                        exportCompletedText = {menuItemsStrings.exportCompletedText}
                        closeBtnText = {menuItemsStrings.closeBtnText}
                        exportSelectObjectText={menuItemsStrings.exportSelectObjectText}
                        exportNoObjectText={menuItemsStrings.exportNoObjectText}
                      />
                    </div>
                  </div>

                </div>

              </div>

            </div>


            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 remove-header-spacing">
                  {/* FilterPane */}
                  <QlikCard
                    id="cpcVJQ"
                    height="min(calc(78vh - 263px + 90px + 8px + 18.8px + 4px + 90px), calc(320px + 38px + 90px + 8px + 18.8px + 4px + 90px))"
                    showHeader={false}
                    showMaximize={false}
                    showExport={false}
                    showOverlayer={false}
                  />
                  <QlikObject
                    id="661b9269-6950-47c3-94cb-faab1b03e6d8"
                    height="min(calc(10.5vh + 2px), 64px)"
                    showHeader={false}
                    showMaximize={false}
                    showExport={false}
                    showOverlayer={false}
                  />
                  {/* Columns Selector */}
                  <QlikCard
                    id="be4c2956-ed56-446d-8149-964410f90cb7"
                    height="max(calc(100vh - 365px)/2 + 161px - min(calc(10.5vh + 2px), 64px) - 12px, 380px)"
                    showHeader={false}
                    showMaximize={false}
                    showExport={false}
                    showOverlayer={false}
                  />

            </div>

          </div>

          <div className="row mb-2">
            <div className="col-md-2 col-sm-3 col-2">
              <QlikObject
                id="74136b82-1249-4a30-b817-4d5d51631a4c"
                height="0px"
                showLoader={false}
              />
            </div>
          </div>
          
        </div>
    </section>
  );
}
